import {createSelector} from 'reselect';

const selectQueryToolState = state => state.queryToolState;

export const selectQueryToolColumns = createSelector(
    [selectQueryToolState],
    state => state.columns
);

export const selectQueryToolCount = createSelector(
    [selectQueryToolState],
    state => state.count
);

export const selectQueryDefinition = createSelector(
    [selectQueryToolState],
    ({
        page,
        sorted,
        columns,
        pageSize,
        useGroupBy,
        useLocalTime,
        speciesListId,
        localTimeZone,
    }) => ({
        page,
        sorted,
        columns: columns.map(column => {
            // NOTE: when comparing saved query definitions (e.g. in TableTitle),
            // object key ordering matters because persisted definitions come back
            // from the API in this exact field order. Keep the DB-aligned order to
            // avoid false positives when diffing definitions.
            const fields = ['guid', 'name', 'title', 'filters', 'aggregate'];
            const result = {};

            fields.forEach(field => {
                if (column.data[field] !== undefined) {
                    result[field] = column.data[field];
                }
            });

            return result;
        }),
        pageSize,
        useGroupBy,
        useLocalTime,
        speciesListId: speciesListId ?? null,
        localTimeZone: useLocalTime ? localTimeZone : null,
    })
);

export const selectHasQueryColumns = createSelector(
    [selectQueryToolColumns],
    columns => columns.length > 0 && columns.some(column => column?.data?.columnSourceGroupName !== undefined)
);

export {selectQueryToolState};
